interface Props {
  onApply: () => void;
}

const perks = [
  { icon: 'ri-medal-fill', text: 'Mama Approved badge on your listing' },
  { icon: 'ri-arrow-up-circle-fill', text: 'Priority listing placement across the platform' },
  { icon: 'ri-calendar-star-fill', text: '1 featured event placement per month' },
  { icon: 'ri-handshake-fill', text: 'Access to collaborations + TMM events' },
  { icon: 'ri-book-open-fill', text: 'Included in seasonal guides + roundups' },
];

export default function MamaPreferredSection({ onApply }: Props) {
  return (
    <section className="py-24 bg-gray-950">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* Left — copy */}
          <div>
            <div className="inline-flex items-center gap-2 bg-rose-500/20 border border-rose-500/30 text-rose-400 text-[11px] font-bold px-3.5 py-1.5 rounded-full uppercase tracking-wider mb-6">
              <i className="ri-vip-crown-fill text-xs" />
              Power Offer
            </div>
            <h2
              className="text-4xl font-extrabold text-white leading-tight mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Mama Preferred<br />
              <span className="text-rose-400">Partner</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-8">
              For businesses that want{' '}
              <strong className="text-white">consistent visibility</strong>, not one-off exposure.
              One plan. Full presence.
            </p>

            {/* Perk list */}
            <ul className="space-y-4 mb-10">
              {perks.map((perk) => (
                <li key={perk.text} className="flex items-center gap-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-rose-500/15 rounded-xl shrink-0">
                    <i className={`${perk.icon} text-rose-400 text-base`} />
                  </div>
                  <span className="text-sm text-gray-300 font-medium">{perk.text}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={onApply}
              className="inline-flex items-center gap-2 px-8 py-4 bg-rose-500 hover:bg-rose-600 text-white text-sm font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-handshake-line text-base" />
              Apply to Become a Partner
              <i className="ri-arrow-right-line text-base" />
            </button>

            <p className="text-gray-600 text-xs mt-4">
              Limited spots available · We review every application
            </p>
          </div>

          {/* Right — pricing card */}
          <div className="lg:flex lg:justify-end">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden w-full max-w-sm">
              {/* Card top bar */}
              <div className="h-1.5 w-full bg-gradient-to-r from-rose-500 to-pink-400" />

              <div className="p-8">
                {/* Badge */}
                <div className="inline-flex items-center gap-1.5 bg-rose-500/20 text-rose-400 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-5">
                  <i className="ri-vip-crown-fill text-xs" />
                  Mama Preferred
                </div>

                {/* Price */}
                <div className="mb-2">
                  <span className="text-5xl font-extrabold text-white">$97</span>
                  <span className="text-gray-400 text-sm ml-2">/month</span>
                </div>
                <p className="text-gray-500 text-xs mb-7 leading-relaxed">
                  Less than $3.25/day to be in front of 3,000+ local moms every month.
                </p>

                {/* Mini perk list */}
                <ul className="space-y-3 mb-8">
                  {perks.map((perk) => (
                    <li key={perk.text} className="flex items-center gap-3">
                      <div className="w-4 h-4 flex items-center justify-center shrink-0">
                        <i className="ri-checkbox-circle-fill text-rose-400 text-sm" />
                      </div>
                      <span className="text-xs text-gray-300">{perk.text}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={onApply}
                  className="w-full py-3.5 bg-rose-500 hover:bg-rose-600 text-white text-sm font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  Apply to Become a Partner
                </button>

                {/* Trust indicators */}
                <div className="mt-5 pt-4 border-t border-white/10 flex items-center justify-center gap-4">
                  <span className="flex items-center gap-1 text-[10px] text-gray-500">
                    <i className="ri-shield-check-line text-gray-600" />
                    Vetted businesses
                  </span>
                  <span className="text-gray-700 text-xs">·</span>
                  <span className="flex items-center gap-1 text-[10px] text-gray-500">
                    <i className="ri-refresh-line text-gray-600" />
                    Cancel anytime
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
